import { render, staticRenderFns } from "./CategoryItemCard.vue?vue&type=template&id=4b172268&scoped=true&"
import script from "./CategoryItemCard.vue?vue&type=script&lang=js&"
export * from "./CategoryItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemCard.vue?vue&type=style&index=0&id=4b172268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b172268",
  null
  
)

export default component.exports